import React from "react";
import {
  Grid,
  Segment,
  Header,
  Icon,
  Table,
  Label,
  Loader,
  Tab,
} from "semantic-ui-react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { StatCard } from "../../StatCard";
import "./AcademicTab.scss";

export function AcademicTab(props) {
  const { academicData } = props;

  if (!academicData) {
    return <Loader active>Cargando datos académicos...</Loader>;
  }

  return (
    <Tab.Pane>
      <Grid stackable>
        <Grid.Row columns={3}>
          <Grid.Column>
            <StatCard
              title="Promedio General"
              value={
                typeof academicData.overallAverage === "object"
                  ? parseFloat(
                      academicData.overallAverage?.averageGrade || 0
                    ).toFixed(2)
                  : academicData.overallAverage || "0"
              }
              icon="graduation cap"
              color="#2185d0"
            />
          </Grid.Column>
          <Grid.Column>
            <StatCard
              title="Estudiantes en Recuperación"
              value={academicData.studentsRequiringRecovery?.count || 0}
              icon="warning"
              color="#db2828"
            />
          </Grid.Column>
          <Grid.Column>
            <StatCard
              title="Top Performers"
              value={academicData.topPerformers?.length || 0}
              icon="trophy"
              color="#fbbd08"
            />
          </Grid.Column>
        </Grid.Row>

        {academicData.topPerformers?.length > 0 && (
          <Grid.Row>
            <Grid.Column width={8}>
              <Segment>
                <Header as="h4">
                  <Icon name="trophy" color="yellow" />
                  Mejores Estudiantes
                </Header>
                <Table basic="very">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Posición</Table.HeaderCell>
                      <Table.HeaderCell>Estudiante</Table.HeaderCell>
                      <Table.HeaderCell textAlign="center">
                        Promedio
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {academicData.topPerformers.map((student, index) => (
                      <Table.Row key={index}>
                        <Table.Cell>
                          <Label
                            circular
                            color={
                              index === 0
                                ? "yellow"
                                : index === 1
                                ? "grey"
                                : "brown"
                            }
                          >
                            {index + 1}
                          </Label>
                        </Table.Cell>
                        <Table.Cell>{student.studentName}</Table.Cell>
                        <Table.Cell textAlign="center">
                          <Label color="green">{student.averageGrade}</Label>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </Segment>
            </Grid.Column>

            <Grid.Column width={8}>
              <Segment>
                <Header as="h4">
                  <Icon name="chart pie" />
                  Distribución de Notas
                </Header>
                {academicData.gradeDistribution ? (
                  <>
                    <div className="grade-distribution-summary">
                      <div className="distribution-item excellent">
                        <span className="value">
                          {academicData.gradeDistribution.excellent || 0}
                        </span>
                        <span className="label">Excelente (17-20)</span>
                      </div>
                      <div className="distribution-item good">
                        <span className="value">
                          {academicData.gradeDistribution.good || 0}
                        </span>
                        <span className="label">Bueno (14-16)</span>
                      </div>
                      <div className="distribution-item regular">
                        <span className="value">
                          {academicData.gradeDistribution.regular || 0}
                        </span>
                        <span className="label">Regular (11-13)</span>
                      </div>
                      <div className="distribution-item deficient">
                        <span className="value">
                          {academicData.gradeDistribution.deficient || 0}
                        </span>
                        <span className="label">Deficiente (0-10)</span>
                      </div>
                    </div>
                    {(() => {
                      const gradeDistributionPieData = [
                        {
                          name: "Excelente (17-20)",
                          value: academicData.gradeDistribution.excellent || 0,
                          fill: "#10b981",
                        },
                        {
                          name: "Bueno (14-16)",
                          value: academicData.gradeDistribution.good || 0,
                          fill: "#3b82f6",
                        },
                        {
                          name: "Regular (11-13)",
                          value: academicData.gradeDistribution.regular || 0,
                          fill: "#f59e0b",
                        },
                        {
                          name: "Deficiente (0-10)",
                          value: academicData.gradeDistribution.deficient || 0,
                          fill: "#ef4444",
                        },
                      ].filter((item) => item.value > 0);

                      return gradeDistributionPieData.length > 0 ? (
                        <div
                          style={{
                            width: "100%",
                            height: 200,
                            marginTop: "1rem",
                          }}
                        >
                          <ResponsiveContainer>
                            <PieChart>
                              <Pie
                                data={gradeDistributionPieData}
                                cx="50%"
                                cy="50%"
                                innerRadius={50}
                                outerRadius={80}
                                paddingAngle={3}
                                dataKey="value"
                              >
                                {gradeDistributionPieData.map(
                                  (entry, index) => (
                                    <Cell
                                      key={`cell-${index}`}
                                      fill={entry.fill}
                                    />
                                  )
                                )}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>
                        </div>
                      ) : null;
                    })()}
                  </>
                ) : (
                  <p>No hay datos disponibles</p>
                )}
              </Segment>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </Tab.Pane>
  );
}
